'use strict';

var _createForOfIteratorHelper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _require = require('buffer'),
    Buffer = _require.Buffer;

var crypto = require('libp2p-crypto');

var multibase = require('multibase');

exports = module.exports;
/**
 * Generatea random sequence number.
 *
 * @returns {Buffer}
 * @private
 */

exports.randomSeqno = function () {
  return crypto.randomBytes(8);
};
/**
 * Generate a message id, based on the `from` and `seqno`.
 *
 * @param {string} from
 * @param {Buffer} seqno
 * @returns {string}
 * @private
 */


exports.msgId = function (from, seqno) {
  return from + seqno.toString('hex');
};
/**
 * Check if any member of the first set is also a member
 * of the second set.
 *
 * @param {Set|Array} a
 * @param {Set|Array} b
 * @returns {boolean}
 * @private
 */


exports.anyMatch = function (a, b) {
  var bHas;

  if (Array.isArray(b)) {
    bHas = function bHas(val) {
      return b.indexOf(val) > -1;
    };
  } else {
    bHas = function bHas(val) {
      return b.has(val);
    };
  }

  var _iterator = _createForOfIteratorHelper(a),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var val = _step.value;

      if (bHas(val)) {
        return true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return false;
};
/**
 * Make everything an array.
 *
 * @param {any} maybeArray
 * @returns {Array}
 * @private
 */


exports.ensureArray = function (maybeArray) {
  if (!Array.isArray(maybeArray)) {
    return [maybeArray];
  }

  return maybeArray;
};
/**
 * Ensures `message.from` is base58 encoded
 * @param {Object} message
 * @param {Buffer|String} message.from
 * @return {Object}
 */


exports.normalizeInRpcMessage = function (message) {
  var m = Object.assign({}, message);

  if (Buffer.isBuffer(message.from)) {
    m.from = multibase.encode('base58btc', message.from).toString().slice(1);
  }

  return m;
};
/**
 * The same as `normalizeInRpcMessage`, but performed on an array of messages
 * @param {Object[]} messages
 * @return {Object[]}
 */


exports.normalizeInRpcMessages = function (messages) {
  if (!messages) {
    return messages;
  }

  return messages.map(exports.normalizeInRpcMessage);
};

exports.normalizeOutRpcMessage = function (message) {
  var m = Object.assign({}, message);

  if (typeof message.from === 'string' || message.from instanceof String) {
    m.from = multibase.decode('z' + message.from);
  }

  return m;
};

exports.normalizeOutRpcMessages = function (messages) {
  if (!messages) {
    return messages;
  }

  return messages.map(exports.normalizeOutRpcMessage);
};